import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 请求角色列表
export const getroomList = params => {
    return get("/admin/room", params);
};

// 修改信息
export const editRoom = params => {
    return put(`/admin/room/${params.id}`, params);
};

// 添加角色
export const addRoom = params => {
    return post("/admin/room", params);
};

// 删除角色
export const deleteRoom = params => {
    return del(`/admin/room/${params}`);
};
//导出
export const exportRoom = params => {
    return get("/admin/roomExport", params);
};


// WEBPACK FOOTER //
// ./src/api/room.js